import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addProphetPage: prophetTypes.AddProphetPage = (data) => {
  return axios.put('/prophet/pages', data);
};

type AddProphetPageOptions = {
  onSuccess: () => void;
  config?: MutationConfig<typeof addProphetPage>;
};

export function useAddProphetPage({ config = {}, onSuccess }: AddProphetPageOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['prophet-pages']);
      toasts.loadingToast.success('add-prophet-page', 'Prophet page added successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-prophet-page', serverMessage);
      config.onError?.(error, variables, context);
    },
    onMutate: (variables) => {
      toasts.loadingToast.loading('add-prophet-page', 'Adding prophet page...');
      return config.onMutate?.(variables);
    },
    mutationFn: addProphetPage,
  });
}
